import axios from 'axios';
import API from '../config/api';
import { auth } from '../firebaseConfig';
import { assertViewerCanWrite } from '../utils/viewerOnly';
import { actionRequest } from './action';

// Explicitly authenticated client for pilot requests. No captured bearer tokens
// or arbitrary URL/headers are persisted in actions.
const client = axios.create({ timeout: 20000 });
export async function sendComplaintAction(action) {
  assertViewerCanWrite();
  const user = auth.currentUser;
  const checkSession = () => {
    if (!user || auth.currentUser?.uid !== action.actorUid || user.uid !== action.actorUid ||
        localStorage.getItem('doctorId') !== action.payload.doctor_id) {
      throw Object.assign(new Error('Sign in with the original doctor account to synchronize.'), { code: 'SESSION_CHANGED' });
    }
  };
  const body = actionRequest(action);
  const send = async forceRefresh => {
    checkSession();
    const token = await user.getIdToken(forceRefresh);
    checkSession();
    return client.post(`${API.BASE_URL}/api/patients/complaint-history`, body, {
      headers: { Authorization: `Bearer ${token}`, 'X-Offline-Operation-Id': action.operationId },
    });
  };
  let response;
  try { response = await send(false); }
  catch (error) {
    if (error?.response?.status !== 401) throw error;
    response = await send(true);
  }
  if (response.data?.operationId !== action.operationId || !response.data?.entry?._id) {
    throw Object.assign(new Error('The server did not confirm this operation.'), { code: 'UNCONFIRMED_RESPONSE' });
  }
  return response.data;
}
